import { StrictMode } from 'react'
import * as ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './app/app'

import * as Sentry from '@sentry/react'

Sentry.init({
  dsn: 'https://01aeec7e22cba0cfa58fe6accacd293b@o4509752168415232.ingest.de.sentry.io/4510742685548624',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  environment: import.meta.env.VITE_ENV || 'development',
  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],
})

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
      <div className="fixed bottom-0 right-0 p-2 text-xs text-gray-500">{'v1.1.0'}</div>
    </BrowserRouter>
  </StrictMode>,
)
